import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=636f5ecd&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"
import style0 from "./Change.vue?vue&type=style&index=0&id=636f5ecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f5ecd",
  null
  
)

export default component.exports